import React, { useState, useEffect } from 'react';
import InputGroup from './ui/InputGroup';
import ResultCard from './ui/ResultCard';
import ToggleGroup from './ui/ToggleGroup';

const BrewCalculator = () => {
  const [potSize, setPotSize] = useState(96); // Default to user's 12-cup pot
  const [strength, setStrength] = useState('standard');
  const [coffeeState, setCoffeeState] = useState('ground');

  const [coffeeOz, setCoffeeOz] = useState(0);
  const [coffeeGrams, setCoffeeGrams] = useState(0);

  useEffect(() => {
    // User's specific math: 
    // Standard: 1.5 oz coffee per 96 oz water
    // Bold: 2.0 oz coffee per 96 oz water
    const ozPerFlOz = strength === 'standard' ? (1.5 / 96) : (2.0 / 96);
    const calculatedCoffeeOz = potSize * ozPerFlOz;
    
    setCoffeeOz(calculatedCoffeeOz.toFixed(2));
    setCoffeeGrams((calculatedCoffeeOz * 28.3495).toFixed(1));
  }, [potSize, strength]);

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h2 className="text-2xl font-bold text-white mb-2">Ounces per Pot</h2>
        <p className="text-slate-400">Calculate the precise dry weight needed for any pot size based on your signature recipes.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        <InputGroup
          label="Pot Size (Water Volume)"
          id="potSize"
          value={potSize}
          onChange={(e) => setPotSize(Number(e.target.value))}
          unit="fl oz"
          min="1"
          helperText="Standard 12-cup commercial pot is 96 fl oz."
        />
        <div className="space-y-6">
          <ToggleGroup
            label="Brew Strength"
            activeValue={strength}
            onChange={setStrength}
            options={[
              { label: 'Standard (1.5oz/96oz)', value: 'standard' },
              { label: 'Bold (2.0oz/96oz)', value: 'bold' },
            ]}
          />
          <ToggleGroup
            label="Coffee State"
            activeValue={coffeeState}
            onChange={setCoffeeState}
            options={[
              { label: 'Whole Bean', value: 'whole' },
              { label: 'Ground', value: 'ground' },
            ]}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
        <ResultCard title="Coffee Needed" value={coffeeOz} unit="oz" highlight={true} />
        <ResultCard title="Metric Weight" value={coffeeGrams} unit="g" />
      </div>
    </div>
  );
};

export default BrewCalculator;